module.exports = __webpack_public_path__ + "images/jawaa221b486f9c1ba713905cd8d4fba823d.png";